import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import {
    StyledInput,
    StyledTextArea,
    StyledLabel,
    StyledCheckbox,
    FormGroup
} from '../../../shared/layout/forms/FormElements';

const PromotionSettings = ({ promotion }) => {
    const daysOfWeek = [
        { label: 'Sunday', value: 'Sunday' },
        { label: 'Monday', value: 'Monday' },
        { label: 'Tuesday', value: 'Tuesday' },
        { label: 'Wednesday', value: 'Wednesday' },
        { label: 'Thursday', value: 'Thursday' },
        { label: 'Friday', value: 'Friday' },
        { label: 'Saturday', value: 'Saturday' }
    ];

    useEffect(() => {
        if (typeof promotion.daysOfWeek === 'string') {
            try {
                promotion.daysOfWeek = JSON.parse(promotion.daysOfWeek);
            } catch (error) {
                console.error('Invalid daysOfWeek format:', promotion.daysOfWeek);
                promotion.daysOfWeek = [];
            }
        }
    }, [promotion]);

    const [, forceUpdate] = useState(0);
    const isEveryday = promotion.daysOfWeek?.length === 7;

    const handleInputChange = (field, value) => {
        promotion[field] = value;
        forceUpdate((prev) => prev + 1);
    };

    const handleDayChange = (day, isChecked) => {
        let updatedDaysOfWeek = [...(promotion.daysOfWeek || [])];

        if (day === 'Everyday') {
            updatedDaysOfWeek = isChecked ? daysOfWeek.map(d => d.value) : [];
        } else {
            if (isChecked) {
                updatedDaysOfWeek.push(day);
            } else {
                updatedDaysOfWeek = updatedDaysOfWeek.filter(d => d !== day);
            }
        }
        handleInputChange('daysOfWeek', updatedDaysOfWeek);
    };

    return (
        <Container>
            <FormGroup>
                <StyledLabel htmlFor="promotionName">Promotion Name</StyledLabel>
                <StyledInput
                    type="text"
                    id="promotionName"
                    value={promotion.name || ''}
                    onChange={(e) => handleInputChange('name', e.target.value)}
                    placeholder="Enter promotion name"
                />
            </FormGroup>

            <FormGroup>
                <StyledLabel htmlFor="description">Description</StyledLabel>
                <StyledTextArea
                    id="description"
                    value={promotion.description || ''}
                    onChange={(e) => handleInputChange('description', e.target.value)}
                    placeholder="Enter promotion description"
                />
            </FormGroup>

            <FormGroup>
                <StyledLabel>Days of the Week</StyledLabel>
                <CheckboxGroup>
                    <CheckboxLabel>
                        <StyledCheckbox
                            checked={isEveryday}
                            onChange={(e) => handleDayChange('Everyday', e.target.checked)}
                        />
                        Everyday
                    </CheckboxLabel>
                    {daysOfWeek.map((day, index) => (
                        <CheckboxLabel key={index}>
                            <StyledCheckbox
                                checked={promotion.daysOfWeek?.includes(day.value)}
                                onChange={(e) => handleDayChange(day.value, e.target.checked)}
                            />
                            {day.label}
                        </CheckboxLabel>
                    ))}
                </CheckboxGroup>
            </FormGroup>

            <FormGroup>
                <StyledLabel htmlFor="startTime">Start Time</StyledLabel>
                <StyledInput
                    type="time"
                    id="startTime"
                    value={promotion.startTime || ''}
                    onChange={(e) => handleInputChange('startTime', e.target.value)}
                />
            </FormGroup>

            <FormGroup>
                <StyledLabel htmlFor="endTime">End Time</StyledLabel>
                <StyledInput
                    type="time"
                    id="endTime"
                    value={promotion.endTime || ''}
                    onChange={(e) => handleInputChange('endTime', e.target.value)}
                />
            </FormGroup>

            <FormGroup>
                <StyledLabel htmlFor="discount">Discount</StyledLabel>
                <StyledInput
                    type="number"
                    id="discount"
                    value={promotion.discount || ''}
                    onChange={(e) => handleInputChange('discount', e.target.value)}
                    placeholder="Enter discount percentage"
                />
            </FormGroup>
        </Container>
    );
};

export default PromotionSettings;

const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.625rem;
`;

const CheckboxGroup = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
    margin-top: 0.5rem;
`;

const CheckboxLabel = styled.label`
    display: flex;
    align-items: center;
    font-size: 0.95rem;
    color: #374151;
    cursor: pointer;
    user-select: none;
`;
